import { MgrRestrictionDef } from '@/models/MgrRestriction/MgrRestrictionDef';

// 機能制限設定（データベース）
export class MgrRestriction {
    public restrictionID = 0
    public name: string = "";
    public serial: Array<bigint> = [BigInt(0), BigInt(0), BigInt(0), BigInt(0)];      // 機能制限ビットフラグ
    public mixedSerial: Array<bigint> = [BigInt(0), BigInt(0), BigInt(0), BigInt(0)];      // 混在状態ビットフラグ（混在状態の項目のみ立てる）
    public selectedCount = 0;

    private readonly defRestriction = new MgrRestrictionDef();

    constructor() {
        this.restrictionID = 0;
        this.name = "";
        this.FromString(this.getMaxString()); // 初期値は全許可
        this.selectedCount = 0;
    }

    /*
     * 比較関数
     */
    public equalsObject(_obj: MgrRestriction): boolean {
        if (this.restrictionID != _obj.restrictionID) return false;
        if (this.name != _obj.name) return false;
        if (!(this.serial.length === _obj.serial.length && this.serial.map((value, index) => value === _obj.serial[index]))) return false;
        if (!(this.mixedSerial.length === _obj.mixedSerial.length && this.mixedSerial.map((value, index) => value === _obj.mixedSerial[index]))) return false;
        return true;
    }
    
    /*
     * 任意のビットを立てる
     */
    public Set(bit: number) : void {
        this.serial[Math.floor(bit / 64)] |= this._i64bit(bit);
    }
    
    /*
     * 任意のビットを降ろす
     */
    public Clear(bit: number): void {
        this.serial[Math.floor(bit / 64)] &= ~this._i64bit(bit);
    }
    
    /*
     * 任意のビットのON/OFFを取得
     */
    public Get(bit: number): boolean {
        return BigInt(0) != (this.serial[Math.floor(bit / 64)] & this._i64bit(bit));
    }
    
    /*
     * 64桁16進数文字列からビットフラグを作成
     */
    public FromString(text: string): void {
        if (this.serial.length * 16 < text.length) {
            return;
        }

        let hexString = text;
        if (text.length < this.serial.length * 16) {
            // 64文字に満たない場合は0埋め
            let insertLen = this.serial.length * 16 - text.length;
            hexString = '0'.repeat(insertLen) + text;
        }

        for (let i = 0; i < hexString.length / 16; i += 1) {
            const chunk = hexString.slice((this.serial.length - 1 - i) * 16, (this.serial.length - 1 - i) * 16 + 16);
            const val = BigInt(`0x${chunk}`);
            this.serial[i] = val;
        }
    }

    
    /*
     * ビットフラグから64桁16進数文字列を生成
     */
    public ToString(): string {
        let hexString = "";
        for (let i = 0; i < this.serial.length; i += 1) {
            let serialString = "";
            serialString = this.serial[i].toString(16).padStart(16, '0').toUpperCase();
            hexString = serialString + hexString;
        }

        return hexString;
    }


    public _i64bit(bit: number) : bigint {
        return BigInt(1) << BigInt(bit % 64);
    }

    public _i64ValueRef(serial: Array<bigint>, bit: number) : bigint {
        return serial[Math.floor(bit / 64)];
    }
    
    /*
     * 最大値取得（全許可）
     */
    public getMaxString(): string {
        // MgrRestrictionDef.tsで定義済みのビット以外は0(制限)のまま
        let hexMax = "";
        for (let i = 0; i < this.serial.length; i += 1) {
            let cnt = this.defRestriction.MgrRestrictionMax - (64 * i);
            if (64 < cnt) {
                cnt = 64;
            }

            let hexVal = "";
            if (0 < cnt) {
                hexVal = BigInt("0b" + '1'.repeat(cnt)).toString(16).padStart(16, '0').toUpperCase();
            }
            else {
                hexVal = BigInt(0).toString(16).padStart(16, '0').toUpperCase();
            }
            hexMax = hexVal + hexMax;
        }

        return hexMax;
    }
    
    /*
     * 最小値取得（全制限）
     */
    public getMinString(): string {
        return "0000000000000000000000000000000000000000000000000000000000000000";
    }

    /*
     * 任意の混在状態ビットを立てる
     */
    public SetMixedBit(bit: number): void {
        this.mixedSerial[Math.floor(bit / 64)] |= this._i64bit(bit);
    }

    /*
     * 任意の混在状態ビットを降ろす
     */
    public ClearMixedBit(bit: number): void {
        this.mixedSerial[Math.floor(bit / 64)] &= ~this._i64bit(bit);
    }

    /*
     * 任意の混在状態ビットのON/OFFを取得
     */
    public GetMixedBit(bit: number): boolean {
        return BigInt(0) != (this.mixedSerial[Math.floor(bit / 64)] & this._i64bit(bit));
    }
}

// 機能制限設定（通信用）
export class MgrRestrictionPattern {
    public RestrictionID : number = 0
    public Name: string = "";
    public Restriction: string = "";      // 機能制限ビットフラグ

    constructor(RestrictionID: number, Name: string, Restriction: string) {
        this.RestrictionID = RestrictionID;
        this.Name = Name;
        this.Restriction = Restriction;
    }
}

/// <summary>
/// デスクトップアプリケーション（定義値）
/// </summary>
export class LoginUserSetting_MgrRestriction_Def {
    public readonly SCV_MAX_RESTRICTION_PATTERN = 100; // 機能制限設定の最大登録数10件
    public readonly SCV_MAX_RESTRICTION_NAME_LEN = 40; // 機能制限設定名の入力上限40文字（全半角共通）
}